import React from 'react';
import PropTypes from 'prop-types';
import PropertyDetailUtilitiesSection from '../../PropertyDetailUtilitiesSection/PropertyDetailUtilitiesSection';
import DescriptionOfCapability from './DescriptionOfCapability';
import isObjectNullOrEmpty from './isObjectNullOrEmpty';


import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

const NaturalGasSubSectionDetail = ({ util, title }) => (
  <section>
    <ViewerPrimaryColorUserStyle domStyle="color">
      <h4 className="section-title">{title}</h4>
    </ViewerPrimaryColorUserStyle>

    { util.map((provider, i) => {
      return (
        <div className="section-body" key={i}>
          <ul key={i + 1}>
            <PropertyDetailUtilitiesSection util={provider} />

            {!isObjectNullOrEmpty(provider, ['sizeOfLine']) &&
            provider.sizeOfLine !== 'N/A' && provider.sizeOfLine &&
            <li><strong>Size of Line:</strong> {provider.sizeOfLine}&quot;</li>
            }
            {!isObjectNullOrEmpty(provider, ['sizeOfMain']) &&
            provider.sizeOfMain !== 'N/A' && provider.sizeOfMain &&
            <li><strong>Size of Main:</strong> {provider.sizeOfMain}&quot;</li>
            }
            {!isObjectNullOrEmpty(provider, ['pressure']) &&
            provider.pressure !== 'N/A' && provider.pressure &&
            <li><strong>Pressure:</strong> {parseInt(provider.pressure, 10)} psi</li>
            }
          </ul>
          <DescriptionOfCapability util={provider} />
        </div>
      );
    })
    }
  </section>
);

NaturalGasSubSectionDetail.propTypes = {
  title: PropTypes.string,
  util: PropTypes.arrayOf(PropTypes.object),
};

export default NaturalGasSubSectionDetail;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailUtilities/SubUtilityDetailsSections/NaturalGasSubSectionDetail.js